/**
 * As regras do Meta Pixel que valem no navegador e no servidor (brief de
 * 30/10/2026). Só tipos e funções puras: este arquivo vai para o navegador.
 *
 * 🔴 AS PÁGINAS SÃO UMA LISTA FECHADA, de propósito: página de evento nova
 * (grupo, lista, passo 2, GEO) nasce SEM pixel. O passo 2 tem dado de saúde de
 * menor, e `/grupo` e `/geo` têm endereço secreto.
 */

export const COOKIE_DO_CONSENTIMENTO = "camp_cookies";
export const COOKIE_DO_FBCLID = "camp_fbclid";
export const DIAS_DO_CONSENTIMENTO = 180;

export type PaginaDoPixel = "landing" | "inscricao" | "confirmacao";

export type NomeDoEventoMeta = "InitiateCheckout" | "Lead" | "Purchase";

/** O que o navegador precisa para mandar a mesma cópia que o servidor mandou. */
export type DadosDoMeta = {
  eventId: string;
  value: number;
  contentIds: string[];
  numItems: number;
};

export function paginaDoPixel(pathname: string, slugs: readonly string[]): PaginaDoPixel | null {
  const m = pathname.match(/^\/camp\/([^/]+)(?:\/(inscricao|confirmacao\/[0-9a-f-]{36}))?\/?$/i);
  if (!m || !slugs.includes(m[1])) return null;
  if (!m[2]) return "landing";
  return m[2] === "inscricao" ? "inscricao" : "confirmacao";
}

const SUFIXO_DO_EVENTO = { InitiateCheckout: "ic", Lead: "lead", Purchase: "purchase" } as const;

/** O mesmo id no navegador e no servidor é o que deduplica. Compra com pacote usa a principal. */
export function idDoEventoMeta(nome: NomeDoEventoMeta, inscricaoId: string): string {
  return `reg_${inscricaoId}_${SUFIXO_DO_EVENTO[nome]}`;
}

/**
 * "sab-pd-1213" vira "sab-pd". 🔴 O final do código é a faixa de nascimento:
 * junto do e-mail de quem paga, diria à Meta a idade da criança.
 */
export function produtoDaTurma(codigo: string): string {
  return codigo.replace(/-\d{4}$/, "");
}
